
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import TeenOfTheDay from "./pages/TeenOfTheDay";
import Opportunities from "./pages/Opportunities";
import Clubs from "./pages/Clubs";
import ClubDetails from "./pages/ClubDetails";
import Events from "./pages/Events";
import Mentors from "./pages/Mentors";
import BecomeMentor from "./pages/BecomeMentor";
import PitchPlayground from "./pages/PitchPlayground";
import Messages from "./pages/Messages";
import Profile from "./pages/Profile";
import PremiumDashboard from "./pages/PremiumDashboard";
import Admin from "./pages/Admin";
import Pricing from "./pages/Pricing";
import Startups from "./pages/Startups";
import Teenvisor from "./pages/Teenvisor";
import Founders from "./pages/Founders";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import NotFound from "./pages/NotFound";
import { useEffect } from "react";

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    console.log("Platform detected:", navigator.platform);
    console.log("Is native app:", !!(window as any).Capacitor?.isNativePlatform?.());
    console.log("Attempting to render application");
    console.log("Application rendered successfully");
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <AuthProvider>
              <div className="min-h-screen flex flex-col">
                <NavBar />
                <main className="flex-grow">
                  <Routes>
                    <Route path="/" element={<Index />} />
                    <Route path="/auth" element={<Auth />} />
                    <Route path="/teen-of-the-day" element={<TeenOfTheDay />} />
                    <Route
                      path="/dashboard"
                      element={
                        <ProtectedRoute>
                          <Dashboard />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/opportunities"
                      element={
                        <ProtectedRoute>
                          <Opportunities />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/clubs"
                      element={
                        <ProtectedRoute>
                          <Clubs />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/clubs/:id"
                      element={
                        <ProtectedRoute>
                          <ClubDetails />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/events"
                      element={
                        <ProtectedRoute>
                          <Events />
                        </ProtectedRoute>
                      }
                    />
                    <Route path="/mentors" element={<Mentors />} />
                    <Route
                      path="/become-mentor"
                      element={
                        <ProtectedRoute>
                          <BecomeMentor />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/pitch-playground"
                      element={
                        <ProtectedRoute>
                          <PitchPlayground />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/messages"
                      element={
                        <ProtectedRoute>
                          <Messages />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/profile"
                      element={
                        <ProtectedRoute>
                          <Profile />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/premium-dashboard"
                      element={
                        <ProtectedRoute>
                          <PremiumDashboard />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/admin"
                      element={
                        <ProtectedRoute>
                          <Admin />
                        </ProtectedRoute>
                      }
                    />
                    <Route path="/pricing" element={<Pricing />} />
                    <Route path="/startups" element={<Startups />} />
                    <Route
                      path="/teenvisor"
                      element={
                        <ProtectedRoute>
                          <Teenvisor />
                        </ProtectedRoute>
                      }
                    />
                    <Route path="/founders" element={<Founders />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </main>
                <Footer />
              </div>
            </AuthProvider>
          </BrowserRouter>
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
